import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { size } from 'polished'

export const content = css({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  padding: 0,
})

export const labelContainer = css({
  alignItems: 'start',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minWidth: 0,
  whiteSpace: 'nowrap',
})

export const basicCardButton = (theme: Theme): SerializedStyles =>
  css({
    padding: theme.spacing(1),
  })

export const subTitle = css({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textTransform: 'lowercase',
  width: '100%',
})

export const icon = (theme: Theme): SerializedStyles =>
  css({
    ...size(24),
    color: theme.palette.primary.main,
    flexShrink: 0,
    marginLeft: theme.spacing(1),
  })
